export const PLANS = [
  {
    key: "plan1",
    highlighted: false,
    priceMode: "static",
    price: "0",
    featureKeys: ["f1", "f2", "f3", "f4"],
    ctaVariant: "ghost",
    ctaHref: "/login",
  },
  {
    key: "plan2",
    highlighted: true,
    priceMode: "dynamic",
    priceMonthly: 990,
    priceYearly: 790,
    priceOldMonthly: 1188,
    featureKeys: ["f1", "f2", "f3", "f4", "f5"],
    ctaVariant: "gold",
    ctaHref: "/login",
  },
  {
    key: "plan3",
    highlighted: false,
    priceMode: "contact",
    featureKeys: ["f1", "f2", "f3", "f4"],
    ctaVariant: "ghost",
    ctaHref: "#contact",
  },
];